<template>
  <div class="yxb">
    <img src="./img/0.jpg" alt="">
    <img src="./img/1.jpeg" alt="">
    <img src="./img/2.jpeg" alt="">
    <img src="./img/10.jpg" alt="">
    <img src="./img/3.jpeg" alt="">
    <img src="./img/4.jpeg" alt="">
    <img src="./img/5.jpeg" alt="">
    <Swipe :autoplay="3000" indicator-color="white">
      <SwipeItem>
        <img style="margin-bottom: 26px" src="./img/teacher/1.png" alt="">
      </SwipeItem>
      <SwipeItem>
        <img style="margin-bottom: 26px" src="./img/teacher/2.png" alt="">
      </SwipeItem>
      <SwipeItem>
        <img style="margin-bottom: 26px" src="./img/teacher/3.png" alt="">
      </SwipeItem>
      <SwipeItem>
        <img style="margin-bottom: 26px" src="./img/teacher/4.png" alt="">
      </SwipeItem>
      <SwipeItem>
        <img style="margin-bottom: 26px" src="./img/teacher/5.png" alt="">
      </SwipeItem>
    </Swipe>
    <img src="./img/6.jpeg" alt="">
    <Swipe :autoplay="3000" indicator-color="white">
      <SwipeItem v-for="v in videos" :key="v.cover">
        <div style="width: 100%;padding: 0 10px 26px 10px">
          <img style="border-radius: 8px" :src="v.cover" @click="playVideo(v)"/>
        </div>
      </SwipeItem>
    </Swipe>
    <img src="./img/7.jpeg" alt="">
    <div class="say">
      <div class="l">
        <img @click="preView(img['1'])" :src="img['1']" alt="">
        <img @click="preView(img['3'])" :src="img['3']" alt="">
        <img @click="preView(img['5'])" :src="img['5']" alt="">
        <img @click="preView(img['7'])" :src="img['7']" alt="">
      </div>
      <div class="r">
        <img @click="preView(img['2'])" :src="img['2']" alt="">
        <img @click="preView(img['4'])" :src="img['4']" alt="">
        <img @click="preView(img['6'])" :src="img['6']" alt="">
        <img @click="preView(img['8'])" :src="img['8']" alt="">
      </div>
    </div>
    <img src="./img/8.jpeg" alt="">
    <img src="./img/9.jpeg" alt="">
    <ImgPopup ref="ImgPopupRef"/>
    <VideoPopup ref="VideoPopupRef"/>
  </div>
</template>

<script>
import {Swipe, SwipeItem} from 'vant';
import VideoPopup from "./VideoPopup.vue"
import ImgPopup from "./ImgPopup.vue"

export default {
  name: "yxb",
  data: function () {
    return {
      videos: [
        {
          src: 'https://v.hulian120.com/vod/1%E4%BA%A7%E5%93%81%E6%8A%80%E6%9C%AF%E7%B4%A0%E6%9D%90%E5%AD%98%E5%82%A8/%E7%AC%AC%E4%BA%8C%E6%9C%9F%E7%A0%94%E4%BF%AE%E7%8F%AD%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85%E8%A7%86%E9%A2%91%E7%B4%A0%E6%9D%90/3ca9a8e28b6241558be56079be76567d.mp4',
          cover: require('./img/cover/4.jpeg')
        },
        {
          src: "https://v.hulian120.com/vod/1%E4%BA%A7%E5%93%81%E6%8A%80%E6%9C%AF%E7%B4%A0%E6%9D%90%E5%AD%98%E5%82%A8/%E7%AC%AC%E4%BA%8C%E6%9C%9F%E7%A0%94%E4%BF%AE%E7%8F%AD%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85%E8%A7%86%E9%A2%91%E7%B4%A0%E6%9D%90/830f99c49fa34be395a0f353eacec90c.mp4",
          cover: require('./img/cover/1.jpeg')
        },
        {
          src: 'https://v.hulian120.com/vod/1%E4%BA%A7%E5%93%81%E6%8A%80%E6%9C%AF%E7%B4%A0%E6%9D%90%E5%AD%98%E5%82%A8/%E7%AC%AC%E4%BA%8C%E6%9C%9F%E7%A0%94%E4%BF%AE%E7%8F%AD%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85%E8%A7%86%E9%A2%91%E7%B4%A0%E6%9D%90/4f9dc34ea22f4410809b99ee7b6417b4.mp4',
          cover: require('./img/cover/2.jpeg')
        },
        {
          src: 'https://v.hulian120.com/vod/1%E4%BA%A7%E5%93%81%E6%8A%80%E6%9C%AF%E7%B4%A0%E6%9D%90%E5%AD%98%E5%82%A8/%E7%AC%AC%E4%BA%8C%E6%9C%9F%E7%A0%94%E4%BF%AE%E7%8F%AD%E5%95%86%E5%93%81%E8%AF%A6%E6%83%85%E8%A7%86%E9%A2%91%E7%B4%A0%E6%9D%90/aec542ed2cdc433d88813371dd54cb40.mp4',
          cover: require('./img/cover/3.jpeg')
        }
      ],
      img: {
        1: require('./img/say/1.png'),
        2: require('./img/say/2.png'),
        3: require('./img/say/3.png'),
        4: require('./img/say/4.png'),
        5: require('./img/say/5.png'),
        6: require('./img/say/6.png'),
        7: require('./img/say/7.png'),
        8: require('./img/say/8.png'),
      }
    };
  },
  methods: {
    playVideo(v) {
      this.$refs.VideoPopupRef.openPopup(v.src, v.cover)
    },
    preView(s) {
      this.$refs.ImgPopupRef.openPopup(s)
    }
  },
  created() {

  },
  mounted() {

  },

  components: {Swipe, SwipeItem, VideoPopup, ImgPopup}
};
</script>
<style lang="scss" scoped>
.yxb {
  background: #0a3f45;

  .say {
    padding: 0 10px;
    display: flex;

    .l, .r {
      flex: 1;

      img {
        width: 100%;
        margin-bottom: 4px;
      }
    }

    .l {
      margin-right: 2px;
    }

    .r {
      margin-left: 3px;
    }
  }

  img, video {
    width: 100%;
    vertical-align: bottom;
  }
}
</style>
